// 剪切图片名称，只保留文件名如：http://xxxxxx.a.png 剪切为a.png
export function getImgName(str){
  let arr = str.split('.')
  return arr[arr.length - 2] + '.' + arr[arr.length - 1]
}

export function hidePhoneMiddle(phone) {
  if(!phone) return
  return phone.slice(0, 3) + '****' + phone.slice(-4);
}